var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGaugeIndicator = function SvgGaugeIndicator(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 189,
    viewBox: "0 0 258 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_191_99317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 186,
    height: 172,
    rx: 15,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.393,
    y: 37.7611,
    width: 2.61567,
    height: 14.4083,
    rx: 1.30783,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.697,
    y: 38.0804,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(7.82609 136.697 38.0804)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.564,
    y: 39.7399,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(15.6522 145.564 39.7399)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.119,
    y: 42.5914,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(23.4783 154.119 42.5914)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.209,
    y: 46.5809,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(31.3043 162.209 46.5809)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.678,
    y: 51.635,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(39.1304 169.678 51.635)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.391,
    y: 57.6589,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(46.9565 176.391 57.6589)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.217,
    y: 64.5405,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(54.7826 182.217 64.5405)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.055,
    y: 72.1519,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(62.6087 187.055 72.1519)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.811,
    y: 80.3508,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(70.4348 190.811 80.3508)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.416,
    y: 88.985,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(78.2609 193.416 88.985)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.82,
    y: 97.8936,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(86.087 194.82 97.8936)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 106.91,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(93.913 195 106.91)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.947,
    y: 115.867,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(101.739 193.947 115.867)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.688,
    y: 124.598,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(109.565 191.688 124.598)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.26,
    y: 132.939,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(117.391 188.26 132.939)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.727,
    y: 140.736,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(125.217 183.727 140.736)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.176,
    y: 147.843,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(133.043 178.176 147.843)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.707,
    y: 154.128,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(140.87 171.707 154.128)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.443,
    y: 159.474,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(148.696 164.443 159.474)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.791,
    y: 160.833,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-148.696 95.791 160.833)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.3223,
    y: 155.779,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-140.87 88.3223 155.779)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6094,
    y: 149.755,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-133.043 81.6094 149.755)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7832,
    y: 142.873,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-125.217 75.7832 142.873)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9453,
    y: 135.262,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-117.391 70.9453 135.262)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.1895,
    y: 127.063,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-109.565 67.1895 127.063)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.584,
    y: 118.429,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-101.739 64.584 118.429)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.1797,
    y: 109.52,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-93.913 63.1797 109.52)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 100.504,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-86.087 63 100.504)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0527,
    y: 91.5467,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-78.2609 64.0527 91.5467)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3125,
    y: 82.8161,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-70.4348 66.3125 82.8161)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7402,
    y: 74.4746,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-62.6087 69.7402 74.4746)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2734,
    y: 66.6779,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-54.7826 74.2734 66.6779)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.8242,
    y: 59.5711,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-46.9565 79.8242 59.5711)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.293,
    y: 53.2861,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-39.1304 86.293 53.2861)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5566,
    y: 47.9404,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-31.3043 93.5566 47.9404)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.48,
    y: 43.6337,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-23.4783 101.48 43.6337)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.916,
    y: 40.4458,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-15.6522 109.916 40.4458)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.709,
    y: 38.4364,
    width: 2.61639,
    height: 14.3902,
    rx: 1.3082,
    transform: "rotate(-7.82609 118.709 38.4364)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.631 90.2529C121.535 90.2529 121.461 90.2266 121.409 90.1741C121.361 90.1168 121.337 90.0404 121.337 89.9448V85.4526C121.337 85.3523 121.363 85.2783 121.416 85.2305C121.468 85.178 121.542 85.1517 121.638 85.1517H123.336C123.876 85.1517 124.291 85.2783 124.582 85.5314C124.874 85.7846 125.02 86.1452 125.02 86.6133C125.02 86.9094 124.953 87.1674 124.819 87.3871C124.69 87.602 124.499 87.7668 124.246 87.8814C123.993 87.9913 123.689 88.0462 123.336 88.0462L123.407 87.9531H123.551C123.737 87.9531 123.899 88.0008 124.038 88.0964C124.176 88.1919 124.303 88.3447 124.418 88.5549L125.105 89.8374C125.144 89.9042 125.16 89.9711 125.156 90.038C125.156 90.1001 125.134 90.1526 125.091 90.1956C125.048 90.2338 124.986 90.2529 124.905 90.2529C124.824 90.2529 124.757 90.2338 124.704 90.1956C124.652 90.1574 124.606 90.1025 124.568 90.0308L123.787 88.5836C123.677 88.3782 123.551 88.242 123.407 88.1752C123.264 88.1035 123.076 88.0677 122.841 88.0677H121.924V89.9448C121.924 90.0404 121.901 90.1168 121.853 90.1741C121.805 90.2266 121.731 90.2529 121.631 90.2529ZM121.924 87.602H123.25C123.642 87.602 123.938 87.5208 124.138 87.3584C124.339 87.1912 124.439 86.9429 124.439 86.6133C124.439 86.2933 124.339 86.0521 124.138 85.8897C123.938 85.7225 123.642 85.6389 123.25 85.6389H121.924V87.602ZM126.423 90.2529C126.328 90.2529 126.254 90.2266 126.201 90.1741C126.154 90.1168 126.13 90.0404 126.13 89.9448V85.4526C126.13 85.3523 126.156 85.2783 126.208 85.2305C126.261 85.178 126.335 85.1517 126.431 85.1517H128.129C128.668 85.1517 129.084 85.2855 129.375 85.5529C129.667 85.8156 129.812 86.1882 129.812 86.6706C129.812 87.1483 129.667 87.5208 129.375 87.7883C129.084 88.0558 128.668 88.1895 128.129 88.1895H126.717V89.9448C126.717 90.0404 126.693 90.1168 126.645 90.1741C126.598 90.2266 126.524 90.2529 126.423 90.2529ZM126.717 87.6952H128.057C128.444 87.6952 128.735 87.6092 128.931 87.4372C129.132 87.2605 129.232 87.005 129.232 86.6706C129.232 86.3315 129.132 86.076 128.931 85.904C128.735 85.7273 128.444 85.6389 128.057 85.6389H126.717V87.6952ZM130.95 90.2529C130.864 90.2529 130.797 90.229 130.749 90.1813C130.702 90.1287 130.678 90.0571 130.678 89.9663V85.3882C130.678 85.2926 130.702 85.221 130.749 85.1732C130.797 85.1255 130.864 85.1016 130.95 85.1016C131.026 85.1016 131.086 85.1183 131.129 85.1517C131.177 85.1804 131.22 85.2305 131.258 85.3022L133.221 88.9991H133.006L134.962 85.3022C135 85.2305 135.041 85.1804 135.084 85.1517C135.127 85.1183 135.189 85.1016 135.27 85.1016C135.351 85.1016 135.416 85.1255 135.464 85.1732C135.512 85.221 135.535 85.2926 135.535 85.3882V89.9663C135.535 90.0571 135.512 90.1287 135.464 90.1813C135.421 90.229 135.354 90.2529 135.263 90.2529C135.177 90.2529 135.11 90.229 135.063 90.1813C135.015 90.1287 134.991 90.0571 134.991 89.9663V85.9398H135.163L133.372 89.3C133.338 89.3621 133.302 89.4075 133.264 89.4361C133.231 89.46 133.181 89.472 133.114 89.472C133.047 89.472 132.994 89.4576 132.956 89.429C132.918 89.4003 132.884 89.3573 132.856 89.3L131.043 85.9327H131.215V89.9663C131.215 90.0571 131.191 90.1287 131.143 90.1813C131.101 90.229 131.036 90.2529 130.95 90.2529Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.253 117.365C116.913 117.365 116.65 117.272 116.465 117.087C116.279 116.901 116.186 116.631 116.186 116.275V113.793H109.739C109.399 113.793 109.12 113.716 108.904 113.562C108.703 113.407 108.602 113.167 108.602 112.843C108.602 112.657 108.649 112.464 108.741 112.263C108.834 112.062 108.997 111.791 109.229 111.451L116.117 101.409C116.287 101.177 116.465 100.999 116.65 100.875C116.851 100.752 117.075 100.69 117.323 100.69C117.601 100.69 117.833 100.783 118.018 100.968C118.219 101.138 118.32 101.409 118.32 101.78V111.961H119.897C120.237 111.961 120.492 112.039 120.662 112.193C120.832 112.348 120.917 112.572 120.917 112.866C120.917 113.175 120.832 113.407 120.662 113.562C120.492 113.716 120.237 113.793 119.897 113.793H118.32V116.275C118.32 116.631 118.227 116.901 118.042 117.087C117.856 117.272 117.593 117.365 117.253 117.365ZM116.186 111.961V103.38H116.766L110.504 112.541V111.961H116.186ZM128.747 117.411C127.882 117.411 127.008 117.288 126.127 117.04C125.261 116.778 124.472 116.383 123.761 115.858C123.56 115.718 123.421 115.556 123.344 115.371C123.282 115.17 123.274 114.976 123.32 114.791C123.367 114.605 123.46 114.451 123.599 114.327C123.738 114.188 123.9 114.11 124.086 114.095C124.287 114.08 124.495 114.141 124.712 114.281C125.33 114.713 125.972 115.038 126.637 115.255C127.302 115.456 127.998 115.556 128.724 115.556C129.451 115.556 130.077 115.417 130.603 115.139C131.129 114.86 131.531 114.474 131.809 113.979C132.103 113.484 132.249 112.904 132.249 112.24C132.249 111.219 131.948 110.384 131.345 109.735C130.742 109.085 129.923 108.761 128.887 108.761C128.253 108.761 127.665 108.877 127.124 109.109C126.598 109.325 126.104 109.696 125.64 110.222C125.531 110.346 125.392 110.454 125.222 110.547C125.068 110.639 124.89 110.686 124.689 110.686C124.395 110.686 124.171 110.608 124.016 110.454C123.862 110.284 123.784 110.06 123.784 109.781V101.826C123.784 101.517 123.869 101.277 124.039 101.107C124.209 100.937 124.449 100.852 124.758 100.852H132.574C132.883 100.852 133.123 100.929 133.293 101.084C133.463 101.239 133.548 101.463 133.548 101.757C133.548 102.05 133.463 102.282 133.293 102.452C133.123 102.607 132.883 102.684 132.574 102.684H125.895V108.877H125.292C125.709 108.258 126.266 107.779 126.962 107.439C127.673 107.099 128.454 106.929 129.304 106.929C130.34 106.929 131.229 107.153 131.971 107.601C132.729 108.034 133.316 108.645 133.734 109.433C134.151 110.206 134.36 111.111 134.36 112.147C134.36 113.167 134.128 114.08 133.664 114.884C133.216 115.672 132.574 116.291 131.739 116.739C130.904 117.187 129.907 117.411 128.747 117.411ZM142.654 117.411C141.788 117.411 140.914 117.288 140.033 117.04C139.167 116.778 138.379 116.383 137.667 115.858C137.466 115.718 137.327 115.556 137.25 115.371C137.188 115.17 137.18 114.976 137.227 114.791C137.273 114.605 137.366 114.451 137.505 114.327C137.644 114.188 137.807 114.11 137.992 114.095C138.193 114.08 138.402 114.141 138.618 114.281C139.237 114.713 139.878 115.038 140.543 115.255C141.208 115.456 141.904 115.556 142.631 115.556C143.357 115.556 143.984 115.417 144.509 115.139C145.035 114.86 145.437 114.474 145.715 113.979C146.009 113.484 146.156 112.904 146.156 112.24C146.156 111.219 145.854 110.384 145.251 109.735C144.648 109.085 143.829 108.761 142.793 108.761C142.159 108.761 141.572 108.877 141.03 109.109C140.505 109.325 140.01 109.696 139.546 110.222C139.438 110.346 139.299 110.454 139.129 110.547C138.974 110.639 138.796 110.686 138.595 110.686C138.301 110.686 138.077 110.608 137.923 110.454C137.768 110.284 137.691 110.06 137.691 109.781V101.826C137.691 101.517 137.776 101.277 137.946 101.107C138.116 100.937 138.355 100.852 138.665 100.852H146.481C146.79 100.852 147.029 100.929 147.2 101.084C147.37 101.239 147.455 101.463 147.455 101.757C147.455 102.05 147.37 102.282 147.2 102.452C147.029 102.607 146.79 102.684 146.481 102.684H139.801V108.877H139.198C139.616 108.258 140.172 107.779 140.868 107.439C141.579 107.099 142.36 106.929 143.21 106.929C144.246 106.929 145.135 107.153 145.878 107.601C146.635 108.034 147.223 108.645 147.64 109.433C148.058 110.206 148.266 111.111 148.266 112.147C148.266 113.167 148.034 114.08 147.571 114.884C147.122 115.672 146.481 116.291 145.646 116.739C144.811 117.187 143.813 117.411 142.654 117.411Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_191_99317",
    x: 0,
    y: 0,
    width: 258,
    height: 244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.05 0 0 0 0 0.0555 0 0 0 0 0.1875 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_99317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_99317",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGaugeIndicator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gauge-indicator.277047b10e297b7c36307aa0ad135c6b.svg";